import { render, staticRenderFns } from "./UserRatingsInfo.vue?vue&type=template&id=e12b565a"
import script from "./UserRatingsInfo.vue?vue&type=script&lang=js"
export * from "./UserRatingsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports